const offices = [
  { name: 'Grand Junction', address: '125 North 8th St., Grand Junction, CO 81501', phone: '970-251-8256', sub: 'Mesa County' },
  { name: 'Denver', address: '14175 E 42nd Ave., Denver, CO 80239', phone: '720-902-9790', sub: 'Denver County' },
  { name: 'Aurora', address: '3538 Peoria St., Aurora, CO 80010', phone: '720-709-2350', sub: 'Arapahoe County' },
  { name: 'Boulder', address: '4525 Broadway, Boulder, CO 80304', phone: '720-782-0477', sub: 'Boulder County' },
  { name: 'Englewood', address: '12656 East Jamison Pl. #12, Englewood, CO 80112', phone: '720-759-2064', sub: 'Arapahoe County' },
  { name: 'Aspen', address: '401 Aspen Airport Business Center, Aspen, CO 81611', phone: '970-808-0075', sub: 'Pitkin County' },
  { name: 'Glenwood Springs', address: '6690 CO-82, Suite A, Glenwood Springs, CO 81601', phone: '970-633-1472', sub: 'Garfield County' },
  { name: 'Basalt', address: '115 Park Ave., Unit #178, Basalt, CO 81621', phone: '970-645-8956', sub: 'Eagle County' },
  { name: 'Vail', address: '616 W. Lionshead Cir., Vail, CO 81657', phone: '970-579-4098', sub: 'Eagle County' },
  { name: 'Steamboat Springs', address: '1920 Bridge Ln., Unit 8a, Steamboat Springs, CO 80487', phone: '970-500-8045', sub: 'Routt County' },
  { name: 'Rifle', address: '1595 Airport Rd., Rifle, CO 81650', phone: '970-478-1788', sub: 'Garfield County' },
  { name: 'Parachute', address: '111 N Russey, Unit C, Parachute, CO 81635', phone: '970-427-0722', sub: 'Garfield County' },
];

interface ServiceAreasSectionProps {
  extraCities?: string[];
  locationNote?: string;
}

export default function ServiceAreasSection({
  locationNote = 'Colorado & Surrounding Regions',
}: ServiceAreasSectionProps) {

  return (
    <section className="bg-ecos-charcoal py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-14">
          <div className="lg:col-span-5">
            <p className="text-ecos-green text-xs uppercase tracking-widest font-semibold mb-4">Coverage Area</p>
            <h2 className="font-serif text-white text-4xl lg:text-5xl font-semibold leading-tight">
              Serving {locationNote}
            </h2>
          </div>
          <div className="lg:col-span-7 flex items-end">
            <p className="text-white/45 text-base leading-relaxed">
              ECOS Environmental &amp; Disaster Restoration maintains certified teams across 12 Colorado locations, serving commercial, industrial, and government clients throughout the state. Emergency response available 24/7.
            </p>
          </div>
        </div>

        {/* Map + office grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 mb-8">

          {/* Map */}
          <div className="lg:col-span-7 rounded-sm overflow-hidden border border-white/10" style={{ minHeight: '420px' }}>
            <iframe
              title="ECOS Environmental Office Locations — Colorado"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1569268.3193068!2d-107.5!3d39.5!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876a81729e32535f%3A0xde8e9a53e6d3ef5c!2sColorado!5e0!3m2!1sen!2sus!4v1700000000000"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '420px' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          {/* Office list */}
          <div className="lg:col-span-5 flex flex-col gap-3">
            <div className="grid grid-cols-2 gap-2 flex-1">
              {offices.slice(0, 8).map((office) => (
                <div
                  key={office.name}
                  className="flex flex-col bg-ecos-charcoal-light border border-white/10 hover:border-ecos-green px-4 py-3 rounded-sm transition-colors duration-200 cursor-default group"
                >
                  <div className="flex items-center gap-2 mb-1">
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-fill text-ecos-green text-xs"></i>
                    </div>
                    <span className="text-white text-sm font-semibold group-hover:text-ecos-green transition-colors">{office.name}</span>
                  </div>
                  <span className="text-white/35 text-xs pl-6">{office.sub}</span>
                  <a href={`tel:+1${office.phone.replace(/-/g, '')}`} className="text-ecos-green/70 hover:text-ecos-green text-xs pl-6 mt-1 transition-colors cursor-pointer whitespace-nowrap">{office.phone}</a>
                </div>
              ))}
            </div>

            <div className="bg-ecos-charcoal-light border border-white/10 rounded-sm px-5 py-4">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-8 h-8 flex items-center justify-center bg-ecos-green/20 rounded-sm flex-shrink-0">
                  <i className="ri-alarm-warning-line text-ecos-green text-base"></i>
                </div>
                <span className="text-white font-semibold text-sm">24/7 Emergency Response</span>
              </div>
              <p className="text-white/45 text-xs leading-relaxed mb-3">
                Environmental emergencies require immediate action. Our rapid-response teams are deployed throughout Colorado.
              </p>
              <a
                href="tel:+18888685420"
                className="flex items-center justify-center gap-2 bg-ecos-green hover:bg-ecos-green-light text-white text-sm font-semibold py-2.5 rounded-sm transition-colors cursor-pointer whitespace-nowrap w-full"
              >
                <i className="ri-phone-fill text-sm"></i>
                888-868-5420
              </a>
            </div>
          </div>

        </div>

        {/* Remaining offices strip */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {offices.slice(8).map((office) => (
            <div key={office.name} className="bg-ecos-charcoal-light border border-white/10 hover:border-ecos-green px-4 py-3 rounded-sm transition-colors cursor-default group">
              <div className="flex items-center gap-2 mb-1">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-fill text-ecos-green text-xs"></i>
                </div>
                <span className="text-white text-sm font-semibold group-hover:text-ecos-green transition-colors">{office.name}</span>
              </div>
              <a href={`tel:+1${office.phone.replace(/-/g, '')}`} className="text-ecos-green/70 hover:text-ecos-green text-xs pl-6 transition-colors cursor-pointer whitespace-nowrap">{office.phone}</a>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
